import { message, Modal, Result, Spin, ConfigProvider } from "antd";
import "antd/dist/antd.css";
import React, { Component } from "react";
import axios from "axios";
import firebase, { initFirebase } from "./Firebase.js";

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import "./App.css";
import "./fonts.css";
// Per-mode login/register pages replaced by shared pages (originals preserved as *.bak.js)
import SharedLoginPage from "./pages/SharedLoginPage";
import SharedRegisterPage from "./pages/SharedRegisterPage";
// import { ConnectedRouter as Router } from 'react-router-redux'
import { AnimatePresence } from "framer-motion";
import "react-grid-layout/css/styles.css";
import { connect } from "react-redux";
import "react-resizable/css/styles.css";
import {
  alert,
  loadUserData,
  logout,
  requestServerPost,
  requestServerGet,
  loadAccounts,
  selectPage,
  requestCoreAPIServerPost,
  setActiveAccountId,
  reloadBrands,
} from "./actions";
import PopupManager from "./managers/PopupManager";
import BranchPage from "./pages/branch";
import BrandPage from "./pages/brand";
import CampaignPage from "./pages/campaign";
import EventPage from "./pages/event";
import HomePage from "./pages/HomePage";
import LayoutPage from "./pages/layout";
import MediaPage from "./pages/media";
import MediaTrashPage from "./pages/mediatrash";
import PlaylistPage from "./pages/playlist";
import ScreenPage from "./pages/screen";
import TimelinePage from "./pages/timeline";
import WidgetPage from "./pages/widget";
import DashboardPage from "./pages/dashboard";
import ActivityLogPage from "./pages/activitylog";
import MediaLogPage from "./pages/medialog";
import AnalyticsPage from "./pages/analytics";
import LicenseManagement from "./pages/licenseManagement";
import ScrollToTop from "./components/ScrollToTop";
import StringHelper from "./helpers/StringHelper";
import {
  ALL_SERVERS_CONFIG,
  ENABLE_ACCOUNT_SWITCHING,
  SERVER_CONFIG,
  setServerUri,
} from "./Config";
import PermissionManager from "./managers/PermissionManager.js";
import GuestActivationView from "./components/views/GuestActivationView.js";
import VerifyLandingPage from "./pages/verifylanding";
import LiteDashboard from "./pages/lite";
import { config } from "process";
import { ProLanguageProvider } from "./global/ProLanguageContext";

class App extends Component {
  constructor(props) {
    super(props);
    // console.log("constructor app");
    PopupManager.onModalUpdate = this.onModalUpdate;

    this.state = {
      modalVisible: false,
      modalContent: false,
      modalCallBack: () => {},
      modalWidth: "min(1000px, 85vw)",
      serverConfigLoaded: false,
      serverConfigError: false,
    };
    // const encrypted = StringHelper.encryptWithTimeStamp();
    // const decryptedAPI = StringHelper.decryptWithTimeStamp("XU3BQMZJklXOqDPb3izcRyMcIghsMPVSUKcz8n/lEbxjOnBwnut4ZhQ85mD9hbXFghRxLygZh+cwItB71YSZ6Cucro3ukxI5uh+sXQ/EAA/t14CnEpk7pggOLDWNbSp+eYIsx/5pUY9nj7nIPLAhFIT405+mrXx1OPtL5wmG1Ws4/EQt2ox3iJGYNX2MpIoKLfi2hnbM2xhbk457W5VWA0D9kLC5JshgJLvyqZP81Y9KOk7OxOAxqWKrq1FdLeyqohPrNExqHKTjrn8RmsosPekQA+FZ0Cz1MIGiUB9OshFQAgEzy+6VCuI+8MpyEOy01g5Tz+Ncpwpn50D+UwCIlJ3NSS1Gm8cEZnz1dbLfPFTcvoIMdymnsS5E2rzSMgGiA7e3HrRQKjjlVQ5StdCECpE2V2Du8n1K8RjrUQc2nkdKaU3x8USpWH1T8Mvji6jyteiksN6WHdlF0v8C+XetsK9tViOWvvHQ8qTGIO1uKsSbHx6MFtZn0+l0IF1mzEu7E2YVY7zeW+LDLSIfKCPrBhIelauPj+lnbA6/zvXK5atnOSN8In/m7y/hNW6Qyag+o+2kJ6NthtGD26qrOuzI1GcrFB+TS6BebKxTj6tQ0/GhJhqanTE8uETWii9BJNHin5eWnMJ65Ima7fyuX2kB3az9PwTkE501JZIevBbove8S/T8HJVJ7I2PiWdX5A60GLPhqAaYELW9qLHtD/pJJsOF+/t6U3K+X3lDx7lFxf1s2Jj8yoLfZUVQCJp9y63fo3BijlHCts4cyEjh7LmfWqQVDo4vSwa/klHBJTGhkNutDaFMCEMvwVPoOjIUZUMQ+IXh1RDOpY5Yzw1hpyYvddAwhO+JvQTOS8CfnA1eC7mGJzbRspqSnWjITJJYEfTw1ncCpYZLIOJ57ejyl6psE944JkW0CwvvG2jni6zpEgW8cHLnTlQScnIkGgHGVKkF8tvHGDMweZ6mAC9VYh4UNWyKSMUX7O3baIFb9FEVFiPEFUQs5G54eS45fUwxtB83M+q4Cd6t98X1IYb79VRQe1S4r5ZZOC9OdiZBn56Cu4dPR6p1GAZeX0KK5uiGmG0zJK2glz8I68s3CqBC8a9t1bOHBh0ckRV4fsjiSoU8qmYZBiuJOQ0OiH7uV7W8EmxX4phft1qYWqjFVXwcP5+DTN1ZtCV8cX2HXJY38VuhOE3qSzH1ICi5ro2yfFiqRk957hlF9LIIowva801ltuNmhaCAK0uHEhLSbPFWTn5Lu0L5x49CRFOVwi8KtSIjO95xpzU0SBvQMfmMSBCajOCYp7uLNpZLKw+bmm5T3dT1U/ib9bMSE7GQTrdwjdSsQJGeC3WLSVkPTZvP3L4Iw0QXV9BAcjlhYDspQXTzn4wGciTQrVEInUqIHu6HpcAYEowGCyg6hsNMnXAHAQdg6YN1bOy63LMSW4YF8W+ewko6dwOO8lawSiLvHzN40fst8C3r/B3NzkFOX3kpiC/yZuWjBV+V6cSCoiWSgDQq6G0vvJRfXnHj+wcmZ65ErOLL/qtFnyudSZLLt0uwSHAObwOlrh4B9JJaBT4i1uaE/zpvci0HZL0FtOrygDoknP3WwWvaVk4mHxm5RuHGmU2yJVyArMKrfMn/HNSdufcuQQ7swkb8=", "1756278971");
    // console.log("Encrypted:", encrypted);
    // console.log("Decrypted:", decryptedAPI);
    const {
      loadUserData,
      requestCodexLBServerGet,
      requestServerGet,
      loadAccounts,
    } = this.props;

    var userdata = localStorage.getItem("userdata");

    // console.log("userdata:", userdata);
    if (userdata === null) {
      return;
    }

    var decrypted = Buffer.from(userdata, "base64").toString("ascii");

    var userObj = this.validateDecryptedUserData(decrypted);
    //&& ("token" in userObj) && ("user" in userObj)
    if (userObj != null && userObj.token != undefined) {
      loadUserData(userObj);
      // selectPage(Constants.BRAND_PAGE);

      // Restore accounts list for the session
      const restoredUserId = userObj.user && userObj.user.userid;
      if (restoredUserId && ENABLE_ACCOUNT_SWITCHING) {
        try {
          requestServerGet(
            "get_accountbyuser",
            { userid: restoredUserId },
            {},
            (accountsResponse) => {
              const accounts =
                (accountsResponse &&
                  accountsResponse.data &&
                  accountsResponse.data.data) ||
                [];
              loadAccounts(accounts);

              // Restore persisted account selection if different from the logged-in default
              const savedAccountId = localStorage.getItem("active_account_id");
              const currentAccountId =
                userObj.user && String(userObj.user.accountid);
              if (
                savedAccountId &&
                savedAccountId !== currentAccountId &&
                accounts.length > 0
              ) {
                const accountExists = accounts.some(
                  (a) => String(a.AccountId) === savedAccountId,
                );
                if (accountExists) {
                  // Update Redux immediately so the search bar shows the right account name
                  this.props.setActiveAccountId(savedAccountId);
                  this.props.requestServerPost(
                    "choose_account",
                    { userid: restoredUserId, accountid: savedAccountId },
                    {},
                    (response) => {
                      if (response && response.data) {
                        loadUserData(response.data);
                        // Re-fetch brands with the switched account's token so
                        // BrandPage (which may have already mounted with the default token) reloads.
                        this.props.reloadBrands();
                      }
                    },
                    userObj.token,
                  );
                }
              }
            },
            userObj.token,
          );
          // Restore selected brand and branch from localStorage
          const savedBrandId = localStorage.getItem("active_brand_id");
          const savedBranchId = localStorage.getItem("active_branch_id");
          if (savedBrandId) {
            // Find brand in loaded brands (if available)
            // You may need to adjust this if brands are loaded elsewhere
            // For now, just dispatch selectBrand with ID (actual data will be set by reducer)
            this.props.selectBrand({ BrandID: savedBrandId });
          }
          if (savedBranchId) {
            this.props.selectBranch({ BranchID: savedBranchId });
          }
        } catch (e) {
          console.log("Error restoring accounts on app load:", e);
        }
      }
    }
  }

  getSubdomain = (domain) => {
    // Remove port if exists (e.g., "localhost:3000")
    domain = domain.split(":")[0];

    const parts = domain.split(".");
    // Return the first part only if there are at least 3 parts (sub + domain + tld)
    if (parts.length >= 3) {
      return parts[0]; // e.g., "makro-uat"
    }

    // Otherwise, return null (e.g., "localhost" or "push-signage.com")
    return null;
  };

  getServerConfigFromDomain = () => {
    let domain = window.location.hostname;

    if (domain === "localhost") {
      const url = new URL(SERVER_CONFIG.SERVER_URI);
      domain = url.hostname;
    }
    console.log("domain:", domain);

    const subdomain = this.getSubdomain(domain);
    if (subdomain in ALL_SERVERS_CONFIG) {
      return ALL_SERVERS_CONFIG[subdomain];
    }
    return null;
  };

  initServerConfig = async () => {
    PermissionManager.initPermissionConstants();

    const basePath = process.env.PUBLIC_URL || "";
    const currentPath = window.location.pathname;
    const isLiteRoute = currentPath.startsWith(`${basePath}/lite`);

    console.log(
      "initServerConfig: path =",
      currentPath,
      "| lite =",
      isLiteRoute,
    );

    try {
      const result = await this.loadServerConfig();
      console.log("server config loaded:", result);

      const serverconfig =
        result && "config_json" in result ? result.config_json : null;

      if (serverconfig) {
        if ("server_uri" in serverconfig)
          SERVER_CONFIG.SERVER_URI = serverconfig.server_uri;
        if ("api_path" in serverconfig)
          SERVER_CONFIG.API_PATH = serverconfig.api_path;
        if ("node_server_uri" in serverconfig)
          SERVER_CONFIG.NODE_SERVER_URI = serverconfig.node_server_uri;
        if ("files_server_uri" in serverconfig)
          SERVER_CONFIG.FILES_SERVER_URI = serverconfig.files_server_uri;
        if ("warroom_access_token" in serverconfig)
          SERVER_CONFIG.WARROOM_ACCESS_TOKEN =
            serverconfig.warroom_access_token;
        if ("firebase_config" in serverconfig) {
          await initFirebase(serverconfig.firebase_config);
        }
        console.log("initServerConfig: config applied");
        this.setState({ serverConfigLoaded: true, serverConfigError: false });
      } else {
        if (isLiteRoute) {
          console.warn(
            "initServerConfig: no config, Lite proceeding with defaults",
          );
          this.setState({ serverConfigLoaded: true, serverConfigError: false });
        } else {
          console.error("initServerConfig: no config for non-Lite route");
          this.setState({ serverConfigLoaded: true, serverConfigError: true });
        }
      }
    } catch (error) {
      console.error("initServerConfig error:", error);
      if (isLiteRoute) {
        console.warn("initServerConfig: failed, Lite proceeding with defaults");
        this.setState({ serverConfigLoaded: true, serverConfigError: false });
      } else {
        this.setState({ serverConfigLoaded: true, serverConfigError: true });
      }
    }
  };

  loadServerConfig = async () => {
    return new Promise((resolve, reject) => {
      const { requestCoreAPIServerPost } = this.props;

      let domain = window.location.hostname;

      const paramsString = JSON.stringify({ domain });
      const timestamp = Date.now().toString();
      const encryptedParams = StringHelper.encryptWithTimeStamp(
        paramsString,
        timestamp,
      );

      if (domain === "localhost") {
        const url = new URL(SERVER_CONFIG.SERVER_URI);
        domain = url.hostname;
      }

      // if (SERVER_CONFIG.SERVER_URI.includes("zignstack")) {
      //   const result = { config_json: SERVER_CONFIG };
      //   resolve(result);
      //   return;

      // }
      console.log("domain:", domain);

      requestCoreAPIServerPost(
        "server_config",
        { domain },
        null,
        (response) => {
          console.log("server config response", response);
          if (
            response?.status === 200 &&
            response.data &&
            "status" in response.data &&
            response.data.status === "success"
          ) {
            try {
              let decryptedData = StringHelper.decryptWithTimeStamp(
                response.data.data,
                response.data.timestamp,
              );

              let parsed = decryptedData;
              if (typeof parsed === "string") {
                parsed = JSON.parse(parsed);
                if (typeof parsed === "string") parsed = JSON.parse(parsed);
              }

              parsed = "data" in parsed ? parsed.data : parsed;
              if ("config_json" in parsed) {
                parsed.config_json = JSON.parse(parsed.config_json);
              }

              console.log("Decrypted server config:", parsed);
              resolve(parsed);
            } catch (e) {
              console.error("Error parsing server config:", e);
              reject(e);
            }
          } else {
            console.error("Invalid server config response:", response);
            reject(new Error("Invalid server config response"));
          }
        },
      );
    });
  };

  componentDidMount() {
    this.initServerConfig(); // ✅ safe to call here
  }

  componentDidUpdate(prevProps) {
    if (this.props.alertMessage !== prevProps.alertMessage) {
      if (this.props.alertMessage !== "")
        Modal.error({
          content: this.props.alertMessage,
          afterClose: () => {
            console.log("error closed");
            this.props.alert("");
          },
          onCancel: () => {
            console.log("error cancelled");
            this.props.alert("");
          },
          onOk: () => {
            console.log("error cancelled");
            this.props.alert("");
          },
        });
    }

    if (prevProps.selectedBrandData !== this.props.selectedBrandData) {
      PermissionManager.currentBrandData = this.props.selectedBrandData;
      // console.log("$$$$ selectedBrandData changes " + this.props.selectedBrandData)
    }
  }

  onModalUpdate = (visible, content, callback = () => {}, width = "min(1000px, 85vw)") => {
    if (visible) {
      // Cancel any pending close-callback from a previous popup so it
      // doesn't fire while this new popup is open.
      this._pendingCloseCallback = null;
      this.setState({
        modalVisible: visible,
        modalContent: content,
        modalCallBack: callback,
        modalWidth: width,
      });
    } else {
      // Capture current callback, reset state, then let afterClose call it.
      this._pendingCloseCallback = this.state.modalCallBack;
      this.setState({
        modalVisible: visible,
        modalContent: content,
        modalCallBack: () => {},
      });
    }
  };

  validateDecryptedUserData = (decryptedUserData) => {
    try {
      return JSON.parse(decryptedUserData);
    } catch (e) {
      console.log("invalid decrypted userdata");
      // Modal.info({
      //   title: "Session Expired",
      //   content: message,
      //   onOk: () => this.props.logout(),
      // });
      logout();
      return null;
    }
  };

  renderApplication() {
    // console.log("root");
    return (
      <ConfigProvider>
        <ProLanguageProvider>
          <AnimatePresence exitBeforeEnter>
            <Router key="mainroute" basename={`${process.env.PUBLIC_URL}/`}>
              <ScrollToTop />
              <Switch>
                <Redirect exact from="/" to="/home"></Redirect>
                <Route path="/home">
                  <HomePage />
                </Route>
                <Route path="/lite/login">
                  <SharedLoginPage />
                </Route>
                <Route path="/lite/register">
                  <SharedRegisterPage />
                </Route>
                <Route
                  path={[
                    "/lite/:brandid/:branchid/:menu",
                    "/lite/:brandid/:branchid",
                    "/lite/:brandid",
                    "/lite",
                  ]}
                >
                  <LiteDashboard />
                </Route>
                <Route exact path="/widget">
                  <WidgetPage />
                </Route>
                <Route path="/login">
                  <SharedLoginPage />
                </Route>
                <Route path="/register">
                  <SharedRegisterPage />
                </Route>
                <Route path="/guestactivation">
                  <GuestActivationView />
                </Route>
                <Route path="/verifylanding">
                  <VerifyLandingPage />
                </Route>
                <Route path="/brand">
                  <BrandPage />
                </Route>
                <Route path="/:brandid/dashboard">
                  <DashboardPage />
                </Route>
                <Route path="/:brandid/activitylog">
                  <ActivityLogPage />
                </Route>
                <Route path="/:brandid/medialog">
                  <MediaLogPage />
                </Route>
                <Route path="/:brandid/analytics">
                  <AnalyticsPage />
                </Route>
                <Route exact path="/:brandid/license">
                  <LicenseManagement />
                </Route>
                <Route path="/:brandid/brand_playlist/:playlistid">
                  <PlaylistPage />
                </Route>
                <Route path="/:brandid/brand_playlist">
                  <PlaylistPage />
                </Route>
                <Route path="/:brandid/brand_media">
                  <MediaPage />
                </Route>
                <Route path="/:brandid/brand_media_trash">
                  <MediaTrashPage />
                </Route>
                <Route path="/:brandid/branch">
                  <BranchPage />
                </Route>
                <Route path="/:brandid/:branchid/screen">
                  <ScreenPage />
                </Route>
                <Route path="/:brandid/:branchid/campaign">
                  <CampaignPage />
                </Route>
                <Route exact path="/:brandid/:branchid/widget">
                  <WidgetPage />
                </Route>
                <Route exact path="/:brandid/:branchid/widget/:widgetid">
                  <WidgetPage />
                </Route>
                <Route path="/:brandid/:branchid/timeline">
                  <TimelinePage />
                </Route>
                <Route path="/:brandid/:branchid/media">
                  <MediaPage />
                </Route>
                <Route path="/:brandid/:branchid/media_trash">
                  <MediaTrashPage />
                </Route>
                <Route path="/:brandid/:branchid/playlist/:playlistid">
                  <PlaylistPage />
                </Route>
                <Route path="/:brandid/:branchid/playlist">
                  <PlaylistPage />
                </Route>
                <Route path="/:brandid/:branchid/layout">
                  <LayoutPage />
                </Route>
                <Route path="/:brandid/:branchid/event">
                  <EventPage />
                </Route>
              </Switch>
            </Router>
            <Modal
              key="modal"
              open={this.state.modalVisible}
              footer={null}
              width={this.state.modalWidth}
              centered
              onCancel={PopupManager.closePopup}
              afterClose={() => {
                if (this._pendingCloseCallback) {
                  this._pendingCloseCallback();
                  this._pendingCloseCallback = null;
                }
              }}
              destroyOnClose
            >
              {this.state.modalContent}
            </Modal>
          </AnimatePresence>
        </ProLanguageProvider>
      </ConfigProvider>
    );
  }

  render() {
    if (!this.state.serverConfigLoaded) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spin size="large" tip="Loading"></Spin>
        </div>
      );
    }

    if (this.state.serverConfigError) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Result
            status="404"
            title="404"
            subTitle="Configuration couldn’t be found. Please try again later or contact support."
            // extra={<Button type="primary">Back Home</Button>}
          />
        </div>
      );
    }

    // return <div>{JSON.stringify(SERVER_CONFIG)}</div>
    return this.renderApplication();
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    selectedPage: state.selectedPage,
    selectedBrandData: state.selectedBrandData,
    alertMessage: state.alertMessage,
  };
};

export default connect(mapStateToProps, {
  logout,
  loadUserData,
  selectPage,
  requestServerPost,
  requestServerGet,
  loadAccounts,
  requestCoreAPIServerPost,
  alert,
  setActiveAccountId,
  reloadBrands,
})(App);
